import { UsersEffects } from './users.effect';
import { OrganizationEffects } from './organization.effect';
import { TeamEffects } from './team.effect';

export const effects: any[] = [UsersEffects, OrganizationEffects, TeamEffects];

export * from './users.effect';
export * from './team.effect';
export * from './organization.effect';
